export default "__VITE_ASSET__73497494__"